import React, { useState } from "react";
import styles from "./SignIn.module.css";
import img from "../assets/OTP.png";
import OTPInputScreen from "./OTPInputScreen";
import { useNavigate } from "react-router-dom";

export default function OTPScreen() {
  const [otp, setOtp] = useState(Array(4).fill(""));

  const handleOtpChange = (newOtp) => {
    setOtp(newOtp);
  };

  const handleSubmit = () => {
    alert("OTP Entered: " + otp.join(""));
  };

 const navigate =  useNavigate()

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div className={styles.box}>
        <img src={img} style={{ width: 200, height: 240 }} />
        <div style={{ width: "100%" }}>
          <h5
            style={{
              marginTop: 20,
              display: "flex",
              marginLeft: 10,
              color: "#323232",
              fontFamily: "Inter, sans-serif",
            }}
          >
            Verification Code
          </h5>
        </div>
        <p
          style={{
            padding: 10,
            color: "#B6B6B6",
            fontFamily: "Inter, sans-serif",
            marginTop: -7,
          }}
        >
          We have sent the verification code to your email address and phone
          number
        </p>

        <OTPInputScreen length={4} onChange={handleOtpChange} />

        <button
          style={{
            height: 55,
            width: "95%",
            border: "none",
            background: "#07448E",
            borderRadius: 10,
            color: "#fff",
            fontFamily: "Inter, sans-serif",
            marginTop: 20,
          }}

          onClick={()=>navigate('/SuccessScreen')}
        >
          CONFIRM
        </button>
      </div>
    </div>
  );
}
